module.exports = __webpack_public_path__ + "img/shop.1cb431f0.png";